import { tokens } from '@synergy/theme-palo';

/**
 * Cell typography per the prototype's `.tbl` column classes: `ref` = accent
 * document numbers, `amount` = right-aligned figures, `date` = muted figures,
 * `muted` = secondary grey text.
 *
 * Figures are Inter with digits of equal width, not monospace: beside the
 * row's Inter text, monospace digits at the same size stood a quarter
 * smaller, and the number people search for was the smallest thing in the
 * row (#2318). Equal-width digits keep the columns aligned.
 */
export type PaloColumnVariant = 'ref' | 'amount' | 'date' | 'muted';

export const columnVariantSx: Record<PaloColumnVariant, object> = {
    ref: {
        fontFamily: tokens.font.sans,
        fontVariantNumeric: 'tabular-nums',
        fontSize: '12.5px',
        color: tokens.color.accent,
        fontWeight: 550,
    },
    amount: {
        textAlign: 'right',
        fontFamily: tokens.font.sans,
        fontVariantNumeric: 'tabular-nums',
        fontWeight: 550,
    },
    date: {
        fontVariantNumeric: 'tabular-nums',
        color: tokens.color.ink2,
        fontSize: '12px',
    },
    muted: {
        color: tokens.color.ink2,
    },
};
